import React, { useEffect } from 'react';
import { UCHIRU_LINK } from 'shared/constants';
import { sendEvent } from 'shared/helpers/requests';
import styles from './OneManySorry.module.scss';
import { ONE_MANY_SORRY_TEXTS } from './constants';
import { useLocalStorage } from '../OneToMany/hooks';
import { useFetchTestData } from '../OneToMany/hooks/useFetchTestData';
import { EVENT_SOURCE, EVENT_TYPE } from '../OneToMany/constants';

export function OneManySorry() {
  const handleClick = () => {
    window.location.assign(UCHIRU_LINK);
  };
  const [seenSorry, setSeenSorry] = useLocalStorage('seenSorry', true);

  const { isCourses, isSubjects, isSubscription } = useFetchTestData();

  useEffect(() => {
    if (isCourses) {
      sendEvent({
        eventSource: EVENT_SOURCE.COURSES,
        eventType: EVENT_TYPE.SORRY,
        eventInfo: '',
      });
    }
    if (isSubjects) {
      sendEvent({
        eventSource: EVENT_SOURCE.SHKOLA,
        eventType: EVENT_TYPE.SORRY,
        eventInfo: '',
      });
    }
    if (isSubscription) {
      sendEvent({
        eventSource: EVENT_SOURCE.PODPISKA,
        eventType: EVENT_TYPE.SORRY,
        eventInfo: '',
      });
    }
  }, [isCourses, isSubjects, isSubscription]);

  useEffect(() => {
    if (!seenSorry) {
      setSeenSorry(true);
    }
  }, [seenSorry, setSeenSorry]);

  return (
    <div className={styles.oneManySorryWrap}>
      <h1>{ONE_MANY_SORRY_TEXTS.title}</h1>
      <p className={styles.subtitleDesktop}>{ONE_MANY_SORRY_TEXTS.subtitle}</p>
      <p className={styles.subtitleMobile}>{ONE_MANY_SORRY_TEXTS.subtitleMobile}</p>
      <button type="button" onClick={handleClick}>
        {ONE_MANY_SORRY_TEXTS.button}
      </button>
    </div>
  );
}
